import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Stack } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import MuiBreadcrumbs from 'components/common/MuiBreadcrumbs';
import {
  providerAdminAppointments,
  superAdminAppointments,
} from 'routes/AppUrls';
import ArrowLeftIcon from 'assets/images/arrow-left.png';
import callIcon from 'assets/images/Dashboard/call.png';
import mailIcon from 'assets/images/Dashboard/mail.png';
import PhotoImage from 'assets/images/provider/image4.png';
import HouseIcon from 'assets/images/provider/HouseLine.png';
import ClockIcon from 'assets/images/provider/clock.png';
import AppointmentColor from 'assets/images/sidebar/AppointmentColor.png';
import { useDispatch, useSelector } from 'react-redux';
import { getAppointmentDetailsCallAPI } from 'store/SuperAdmin/getAppointmentDetails/action';
import moment from 'moment';
import { getUserRole } from 'utils/general';
import ReusableButton from 'components/common/Button';
import CommonModal from 'components/common/Modal';
import crossIcon from 'assets/images/crossIcon.svg';
import { Box } from '@mui/material';
import OtpInput from 'components/common/Input/OtpInput';
import ToastNotification from 'components/common/Toast';
import { assignSpecialistVerifyProviderCallAPI } from 'store/ProviderAdmin/assignSpecialistVerify/action';
import { postCompleteJobProviderCallAPI } from 'store/ProviderAdmin/completeJob/action';
import SelectInput from 'components/common/Input/SelectInput';
import { assignSpecialistProviderCallAPI } from 'store/ProviderAdmin/assignSpecialist/action';
import { getAssignSpecialistListProviderCallAPI } from 'store/ProviderAdmin/assignSpecialistList/action';
import SelectSearchInput from 'components/common/Input/SelectSearchInput';
import { ShimmerBox, ShimmerCircle } from 'components/common/Shimmer';

const AppointmentDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userRole = getUserRole();
  const intl = useIntl();
  const { locale } = useContext(LocaleContext);
  const { state } = useLocation();
  const [isModalActive, setIsModalActive] = useState(false);
  const [isAssignModalActive, setIsAssignModalActive] = useState(false);
  const [otp, setOtp] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [isReAssign, setIsReAssign] = useState(false);
  const [conf, setConf] = ToastNotification();

  const appointmentDetailApiData = useSelector(
    (state) => state?.getAppointmentDetailsReducer?.data?.data
  );
  const appointmentDetailLoader = useSelector(
    (state) => state?.getAppointmentDetailsReducer?.loading
  );
  const [appointmentDetail, setAppointmentDetail] = useState(
    appointmentDetailApiData ? appointmentDetailApiData : ''
  );

  const [specialistData, setSpecialistData] = useState([]);
  const [selectSpecialistName, setSelectSpecialistName] = useState('');
  const [selectSpecialistId, setSelectSpecialistId] = useState(null);
  const [selectServiceId, setSelectServiceId] = useState(null);

  const [breadcrumbsList, setBreadcrumbsList] = useState([
    {
      title: <FormattedMessage id="Appointments" />,
      Link:
        userRole === 'super-admin'
          ? superAdminAppointments(locale)
          : providerAdminAppointments(locale),
      isDisbale: false,
    },
    {
      title: <FormattedMessage id="Appointment Details" />,
      Link: '',
      isDisbale: true,
    },
  ]);

  useEffect(() => {
    getAppointmentDetailsApi();
  }, []);

  const getAppointmentDetailsApi = () => {
    dispatch(
      getAppointmentDetailsCallAPI(
        { id: state?.customerId },
        {
          run: true,
          handleFunction: (res) => handleSuccess(res),
          navigate: navigate,
        }
      )
    );
  };

  const handleSuccess = (res) => {
    setAppointmentDetail(res?.data?.data);
  };

  const OtpValidation = (value) => {
    if (value.length > 0 && value.length == 6) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  const handleSubmit = () => {
    if (isValid) {
      handleAssignVerify();
    } else {
      setConf({ msg: 'Please enter correct OTP', variant: 'error' });
    }
  };

  const handleAssignVerify = () => {
    let body = {
      order_id: appointmentDetail?.order_id,
      otp: otp,
      services_id: selectServiceId,
    };

    dispatch(
      assignSpecialistVerifyProviderCallAPI(body, {
        run: true,
        handleFunction: (res) => handleAssignSuccess(res),
        toast: true,
        handleToastError: (res) => handleAssignError(res),
        navigate: navigate,
      })
    );
  };

  const handleAssignSuccess = (res) => {
    setConf({ msg: res?.data?.message, variant: 'success' });
    setIsModalActive(false);
    getAppointmentDetailsApi();
  };

  const handleAssignError = (res) => {
    setConf({ msg: res?.data?.message, variant: 'error' });
  };

  const handleStatusSuccess = (res) => {
    setConf({ msg: res?.data?.message, variant: 'success' });
    getAppointmentDetailsApi();
  };

  const handleStatus = (status, serviceId, orderStatus) => {
    setSelectServiceId(serviceId);
    if (orderStatus === 'upcoming') {
      setOtp('');
      setIsModalActive(true);
    } else if (orderStatus === 'inprogress') {
      let body = {
        order_id: appointmentDetail?.order_id,
        order_status: status,
        services_id: serviceId,
      };
      dispatch(
        postCompleteJobProviderCallAPI(body, {
          run: true,
          handleFunction: (res) => handleStatusSuccess(res),
          toast: true,
          handleToastError: (res) => handleAssignError(res),
          navigate: navigate,
        })
      );
    }
  };

  const handleAssign = (item) => {
    setSelectSpecialistName('');
    setSelectSpecialistId(null);
    setSelectServiceId(null);
    getSpecialistList(appointmentDetail?.order_id, item?.service_id);
    setSelectServiceId(item?.service_id);
    setIsAssignModalActive(true);
  };

  const handleReAssign = (item) => {
    setSelectSpecialistName('');
    setSelectSpecialistId(null);
    setSelectServiceId(null);
    getSpecialistList(appointmentDetail?.order_id, item?.service_id);
    setSelectServiceId(item?.service_id);
    setIsAssignModalActive(true);
    setIsReAssign(true);
  };

  const handleSpecialistChange = (event, value) => {
    setSelectSpecialistName(value?.specialist_name_en);
    setSelectSpecialistId(value?.specialist_id);
  };

  const handleAssignSpecialist = () => {
    if (selectSpecialistName === '') {
      return setConf({
        msg: 'No specialist is available',
        variant: 'error',
      });
    }

    let body = {
      appointment_id: appointmentDetail?.order_id,
      specialist_id: [selectSpecialistId],
      services_id: selectServiceId,
    };

    dispatch(
      assignSpecialistProviderCallAPI(body, {
        reassign: isReAssign,
        run: true,
        handleFunction: (res) => handleSpecialistAssignSuccess(res),
        navigate: navigate,
      })
    );
  };

  const handleSpecialistAssignSuccess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    setIsAssignModalActive(false);
    getAppointmentDetailsApi();
  };

  const getSpecialistList = (orderId, serviceId) => {
    dispatch(
      getAssignSpecialistListProviderCallAPI(
        {},
        {
          orderId: orderId,
          serviceId: serviceId,
          run: true,
          handleFunction: (res) => handleSpecialistListSuccess(res),
          navigate: navigate,
        }
      )
    );
  };

  const handleSpecialistListSuccess = (res) => {
    let filterData = res?.data?.data.specialist_list.filter(
      (val) => val?.is_available === true
    );
    setSpecialistData(filterData);
  };

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <MuiBreadcrumbs size="14" list={breadcrumbsList} />
        <Row className="bc-FFFFFF m-0 p-16 mt-3">
          <Col xs={12} md={12} className="p-0 flex justify-between">
            <Stack direction="horizontal" gap={2} className="items-center">
              <img
                src={ArrowLeftIcon}
                alt="icon"
                style={{ height: '24px', width: '24px' }}
                className="cursor-pointer"
                onClick={() =>
                  navigate(
                    userRole === 'super-admin'
                      ? superAdminAppointments(locale)
                      : providerAdminAppointments(locale)
                  )
                }
              />
              {appointmentDetailLoader ? (
                <ShimmerBox width="200px" height="24px" className={'mb-0'} />
              ) : (
                <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                  <FormattedMessage id="Appointment no." />{' '}
                  {appointmentDetail?.appoinment_id}
                </p>
              )}
            </Stack>
          </Col>

          <Col xs={12} md={12} className="mt-4 border-b pb-4 p-0">
            <div className="gap-3 flex">
              {appointmentDetailLoader ? (
                <ShimmerCircle size="88px" />
              ) : (
                <img
                  src={
                    appointmentDetail?.user_details?.profile_image !== null &&
                    appointmentDetail?.user_details?.profile_image !== undefined
                      ? appointmentDetail?.user_details?.profile_image
                      : PhotoImage
                  }
                  alt={'icon'}
                  style={{
                    height: '88px',
                    width: '88px',
                    borderRadius: '50%',
                  }}
                />
              )}
              <div className="flex-col d-flex justify-between">
                <div>
                  {appointmentDetailLoader ? (
                    <ShimmerBox
                      width="200px"
                      height="24px"
                      className={'mb-0'}
                    />
                  ) : (
                    <p className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                      {appointmentDetail?.user_details?.name}
                    </p>
                  )}
                </div>
                <div>
                  {appointmentDetailLoader ? (
                    <ShimmerBox
                      width="100px"
                      height="21px"
                      className={'mb-0'}
                    />
                  ) : (
                    <p className="p-0 m-0 fs-14 fc-A4AAB2 fw-400 ff-Akkurat">
                      ID : {appointmentDetail?.user_details?.customer_id}
                    </p>
                  )}
                </div>
                <div className="flex gap-5 flex-wrap">
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center"
                  >
                    <img
                      src={callIcon}
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                    />
                    {appointmentDetailLoader ? (
                      <ShimmerBox
                        width="150px"
                        height="21px"
                        className={'mb-0'}
                      />
                    ) : (
                      <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat">
                        {appointmentDetail?.user_details?.contact_number}
                      </p>
                    )}
                  </Stack>
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center"
                  >
                    <img
                      src={mailIcon}
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                    />
                    {appointmentDetailLoader ? (
                      <ShimmerBox
                        width="150px"
                        height="21px"
                        className={'mb-0'}
                      />
                    ) : (
                      <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat">
                        {appointmentDetail?.user_details?.email}
                      </p>
                    )}
                  </Stack>
                </div>
              </div>
            </div>
          </Col>

          <Col xs={12} md={12} className="mt-3 border-b pb-4 p-0">
            <h5 className="p-0 m-0 fs-18 fw-400 fc-292D32 ff-Akkurat_Bold">
              {appointmentDetailLoader ? (
                <ShimmerBox width="200px" height="24px" className={'mb-0'} />
              ) : (
                <FormattedMessage id="Appointment Details" />
              )}
            </h5>
            <div className="flex gap-5 flex-wrap mt-3 pt-1">
              {appointmentDetailLoader ? (
                [1, 2, 3, 4]?.map((index) => (
                  <ShimmerBox
                    width="200px"
                    height="24px"
                    className={'mb-0'}
                    key={index}
                  />
                ))
              ) : (
                <>
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center"
                  >
                    <p className="p-0 m-0 fs-16 fc-9A9A9A fw-400 ff-Akkurat">
                      <FormattedMessage id="Service Type" /> {':'}
                    </p>
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center"
                    >
                      <img
                        src={HouseIcon}
                        alt="icon"
                        style={{ height: '20px', width: '20px' }}
                      />
                      <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                        {appointmentDetail?.service_location}
                      </p>
                    </Stack>
                  </Stack>

                  <Stack
                    direction="horizontal"
                    gap={3}
                    className="items-center"
                  >
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center"
                    >
                      <img
                        src={AppointmentColor}
                        alt="icon"
                        style={{ height: '20px', width: '20px' }}
                      />
                      <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat">
                        {appointmentDetail?.slot_date !== null &&
                        appointmentDetail?.slot_date !== undefined
                          ? moment(appointmentDetail?.slot_date).format(
                              'MMMM DD, YYYY'
                            )
                          : ''}
                      </p>
                    </Stack>
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center"
                    >
                      <img
                        src={ClockIcon}
                        alt="icon"
                        style={{ height: '20px', width: '20px' }}
                      />
                      <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat">
                        {appointmentDetail?.slot_start_time !== null &&
                        appointmentDetail?.slot_start_time !== undefined
                          ? moment(appointmentDetail?.slot_start_time).format(
                              'hh:mm A'
                            )
                          : ''}
                      </p>
                    </Stack>
                  </Stack>

                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center"
                  >
                    <p className="p-0 m-0 fs-16 fc-9A9A9A fw-400 ff-Akkurat">
                      <FormattedMessage id="Location" /> {':'}
                    </p>
                    <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat">
                      {appointmentDetail?.delivery_address}
                    </p>
                  </Stack>
                </>
              )}
            </div>
          </Col>

          {/* {userRole === 'salon-admin' && (
            <Col xs={12} md={12} className="mt-3 border-b pb-4 p-0">
              <h5 className="p-0 m-0 fs-18 fw-400 fc-292D32 ff-Akkurat_Bold">
                <FormattedMessage id="Specialist Details" />
              </h5>

              {appointmentDetail?.specialist_details !== null ? (
                <div className="gap-5 flex mt-3">
                  <div className="gap-3 flex">
                    <img
                      src={
                        appointmentDetail?.specialist_details?.profile_image !==
                          null &&
                        appointmentDetail?.specialist_details?.profile_image !==
                          undefined
                          ? appointmentDetail?.specialist_details?.profile_image
                          : PhotoImage
                      }
                      alt={'icon'}
                      style={{
                        height: '64px',
                        width: '64px',
                        borderRadius: '50%',
                      }}
                    />
                    <div className="flex-col d-flex justify-between">
                      <div>
                        <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                          {appointmentDetail?.specialist_details?.name ||
                            appointmentDetail?.specialist_details?.name_en}
                        </p>
                      </div>
                      <div>
                        <p className="p-0 m-0 fs-14 fc-A4AAB2 fw-400 ff-Akkurat">
                          ID :{' '}
                          {appointmentDetail?.specialist_details?.provider_id}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex-col d-flex justify-between">
                    <div>
                      <p className="p-0 m-0 fs-14 fc-A4AAB2 fw-400 ff-Akkurat">
                        <FormattedMessage id="Contact Info" />
                      </p>
                    </div>
                    <div className="flex gap-5">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <img
                          src={callIcon}
                          alt="icon"
                          style={{ height: '24px', width: '24px' }}
                        />
                        <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat">
                          {
                            appointmentDetail?.specialist_details
                              ?.contact_number
                          }
                        </p>
                      </Stack>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <img
                          src={mailIcon}
                          alt="icon"
                          style={{ height: '24px', width: '24px' }}
                        />
                        <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat">
                          {appointmentDetail?.specialist_details?.email}
                        </p>
                      </Stack>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="gap-5 flex mt-3 justify-center">
                  {'No specialist assigned yet!'}
                </div>
              )}
            </Col>
          )} */}

          {(userRole === 'company-admin' || userRole === 'super-admin') && (
            <Col xs={12} md={12} className="mt-3 border-b pb-4 p-0">
              <h5 className="p-0 m-0 fs-18 fw-400 fc-292D32 ff-Akkurat_Bold">
                {appointmentDetailLoader ? (
                  <ShimmerBox width="200px" height="24px" className={'mb-0'} />
                ) : (
                  <FormattedMessage id="Provider Details" />
                )}
              </h5>
              {appointmentDetailLoader ? (
                <ShimmerBox width="50%" height="50px" className={'mt-3'} />
              ) : (
                <div className="gap-5 flex mt-3">
                  <div className="gap-3 flex">
                    <img
                      src={
                        appointmentDetail?.provider_details?.profile_image !==
                          null &&
                        appointmentDetail?.provider_details?.profile_image !==
                          undefined
                          ? appointmentDetail?.provider_details?.profile_image
                          : PhotoImage
                      }
                      alt={'icon'}
                      style={{
                        height: '64px',
                        width: '64px',
                        borderRadius: '50%',
                      }}
                    />
                    <div className="flex-col d-flex justify-between">
                      <div>
                        <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                          {appointmentDetail?.provider_details?.name_en}
                        </p>
                      </div>
                      <div>
                        <p className="p-0 m-0 fs-14 fc-A4AAB2 fw-400 ff-Akkurat">
                          ID :{' '}
                          {appointmentDetail?.provider_details?.provider_id}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex-col d-flex justify-between">
                    <div>
                      <p className="p-0 m-0 fs-14 fc-A4AAB2 fw-400 ff-Akkurat">
                        <FormattedMessage id="Contact Info" />
                      </p>
                    </div>
                    <div className="flex gap-5">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <img
                          src={callIcon}
                          alt="icon"
                          style={{ height: '24px', width: '24px' }}
                        />
                        <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat">
                          {appointmentDetail?.provider_details?.contact_number}
                        </p>
                      </Stack>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <img
                          src={mailIcon}
                          alt="icon"
                          style={{ height: '24px', width: '24px' }}
                        />
                        <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat">
                          {appointmentDetail?.provider_details?.email}
                        </p>
                      </Stack>
                    </div>
                  </div>
                </div>
              )}
            </Col>
          )}

          <h5 className="p-0 m-0 mt-3 fs-18 fw-400 fc-292D32 ff-Akkurat_Bold">
            {appointmentDetailLoader ? (
              <ShimmerBox width="200px" height="24px" className={'mb-0'} />
            ) : (
              <FormattedMessage id="Services" />
            )}
          </h5>

          {appointmentDetailLoader ? (
            <ShimmerBox width="100%" height="70px" className={'mt-3'} />
          ) : (
            appointmentDetail?.services?.length > 0 &&
            appointmentDetail.services.map((k, i) => (
              <Col xs={12} md={12} className="mt-3 border-b pb-2 p-0">
                <Row className="flex ">
                  <Col xs={12} md={4} className="gap-3 flex items-center">
                    <img
                      src={k?.service_image ? k?.service_image : PhotoImage}
                      alt={'icon'}
                      style={{
                        height: '92px',
                        width: '92px',
                      }}
                    />
                    <div>
                      <p className="p-0 m-0 fs-20 fc-292D32 fw-400 ff-Akkurat_Bold">
                        {k?.service_name}
                      </p>
                      <p className="p-0 m-0 mt-3 fs-16 fc-292D32 fw-400 ff-Akkurat">
                        {k?.description}
                      </p>
                    </div>
                  </Col>

                  {userRole === 'salon-admin' &&
                  appointmentDetail?.order_status !== 'missed' &&
                  appointmentDetail?.order_status !== 'cancelled' ? (
                    <Col
                      xs={12}
                      md={4}
                      className="flex items-center justify-center"
                    >
                      <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat">
                        {'Specialist : '}{' '}
                        {k?.assign_specialist ? (
                          <>
                            {k?.assign_specialist?.name ||
                              k?.assign_specialist?.name_en}
                            {appointmentDetail?.order_status !== 'missed' &&
                              appointmentDetail?.order_status !== 'cancelled' &&
                              appointmentDetail?.order_status !==
                                'completed' && (
                                <ReusableButton
                                  fullWidth={false}
                                  variant="contained"
                                  color="#FFFFFF"
                                  fontSize="12px"
                                  fontWeight="400"
                                  // padding="10px"
                                  height="25px"
                                  bgColor="#1A1A1A"
                                  brColor="#1A1A1A"
                                  fontFamily="Akkurat"
                                  onClick={() => handleReAssign(k)}
                                  style={{ marginLeft: '5px' }}
                                >
                                  <FormattedMessage id="ReAssign" />
                                </ReusableButton>
                              )}
                          </>
                        ) : (
                          <ReusableButton
                            fullWidth={false}
                            variant="contained"
                            color="#FFFFFF"
                            fontSize="12px"
                            fontWeight="400"
                            // padding="10px"
                            height="25px"
                            bgColor="#1A1A1A"
                            brColor="#1A1A1A"
                            fontFamily="Akkurat"
                            onClick={() => handleAssign(k)}
                          >
                            <FormattedMessage id="Assign" />
                          </ReusableButton>
                        )}
                      </p>
                    </Col>
                  ) : userRole === 'specialist-admin' ? (
                    <Col
                      xs={12}
                      md={4}
                      className="flex items-center justify-center"
                    >
                      {k?.appointment_status !== 'upcoming' && (
                        <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold me-2">
                          {'status : '}
                          <span className="p-0 m-0 fs-16 fc-9A9A9A fw-400 ff-Akkurat">
                            {k?.appointment_status}
                          </span>
                        </p>
                      )}

                      {(k?.appointment_status === 'upcoming' ||
                        k?.appointment_status === 'inprogress') && (
                        <ReusableButton
                          fullWidth={false}
                          variant="contained"
                          color="#F5F5F5"
                          fontSize="16px"
                          fontWeight="400"
                          padding="12px 25px"
                          height="44px"
                          bgColor="#292D32"
                          fontFamily="Akkurat"
                          onClick={() =>
                            k?.appointment_status === 'upcoming'
                              ? handleStatus(
                                  'inprogress',
                                  k?.service_id,
                                  k?.appointment_status
                                )
                              : handleStatus(
                                  'completed',
                                  k?.service_id,
                                  k?.appointment_status
                                )
                          }
                        >
                          {k?.appointment_status === 'upcoming' && (
                            <FormattedMessage id="Start Job" />
                          )}
                          {k?.appointment_status === 'inprogress' && (
                            <FormattedMessage id="Complete Job" />
                          )}
                        </ReusableButton>
                      )}
                    </Col>
                  ) : (
                    <Col
                      xs={12}
                      md={4}
                      className="flex items-center justify-center"
                    ></Col>
                  )}

                  <Col xs={12} md={4} className="flex items-center justify-end">
                    <div>
                      <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                        {k?.rating} | {k?.time_required_in_mints} min
                      </p>
                      <p className="p-0 m-0 mt-3 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                        {k?.price} {k?.currency}
                      </p>
                    </div>
                  </Col>
                </Row>
              </Col>
            ))
          )}
        </Row>

        {/*   Modal  */}
        <CommonModal
          padding={'32px 48px'}
          width={'600px'}
          modalActive={isModalActive}
          handleClose={() => setIsModalActive(false)}
          innerContent={
            <Box>
              <Row>
                <Col xs={12} md={12}>
                  <div className="flex justify-between items-center">
                    <h2 className="p-0 m-0 fs-24 fc-292D32 fw-400 ff-Akkurat_Bold">
                      {<FormattedMessage id="Start Service" />}
                    </h2>
                    <img
                      src={crossIcon}
                      alt={'icon'}
                      style={{
                        cursor: 'pointer',
                        height: '32px',
                        width: '32px',
                      }}
                      onClick={() => setIsModalActive(false)}
                    />
                  </div>
                </Col>

                <Col xs={12} md={12} className="mt-3">
                  <p className="p-0 m-0 fs-20 fc-A4AAB2 fw-400 ff-Akkurat">
                    <FormattedMessage id="Please enter the OTP provided by the customer to begin the service." />
                  </p>
                </Col>

                <Col xs={12} md={12} className="mt-3">
                  <OtpInput
                    marginTop="30"
                    TextFieldsProps={{ placeholder: 0 }}
                    validateChar={(val) => !isNaN(val)}
                    value={otp}
                    length={6}
                    onChange={(value) => {
                      setOtp(value);
                      OtpValidation(value);
                    }}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        handleSubmit();
                      }
                    }}
                  />
                </Col>
              </Row>

              <Row className="mt-5 items-center">
                <div className="flex justify-center">
                  <Stack
                    direction="horizontal"
                    gap={3}
                    className="items-center"
                  >
                    <ReusableButton
                      fullWidth={false}
                      variant="outlined"
                      color="#292D32"
                      fontSize="16px"
                      fontWeight="400"
                      padding="12px 25px"
                      height="44px"
                      bgColor="transparent"
                      fontFamily="Akkurat"
                      onClick={() => setIsModalActive(false)}
                    >
                      <FormattedMessage id="Cancel" />
                    </ReusableButton>

                    <ReusableButton
                      fullWidth={false}
                      variant="contained"
                      color="#F5F5F5"
                      fontSize="16px"
                      fontWeight="400"
                      padding="12px 35px"
                      height="44px"
                      bgColor="#292D32"
                      fontFamily="Akkurat"
                      onClick={() => handleSubmit()}
                    >
                      <FormattedMessage id="Start" />
                    </ReusableButton>
                  </Stack>
                </div>
              </Row>
            </Box>
          }
        />
        {/*  Modal  */}

        {/* Edit  Modal  */}
        <CommonModal
          padding={'32px 48px'}
          width={'600px'}
          modalActive={isAssignModalActive}
          handleClose={() => {
            setIsAssignModalActive(false);
            setIsReAssign(false);
          }}
          innerContent={
            <Box>
              <Row>
                <Col xs={12} md={12}>
                  <div className="flex justify-between items-center">
                    <h2 className="p-0 m-0 fs-24 fc-292D32 fw-400 ff-Akkurat_Bold">
                      {<FormattedMessage id="Assign Specialist" />}
                    </h2>
                    <img
                      src={crossIcon}
                      alt={'icon'}
                      style={{
                        cursor: 'pointer',
                        height: '32px',
                        width: '32px',
                      }}
                      onClick={() => {
                        setIsAssignModalActive(false);
                        setIsReAssign(false);
                      }}
                    />
                  </div>
                </Col>

                <Col xs={12} md={12} className="mt-3">
                  <SelectSearchInput
                    label={<FormattedMessage id="Specialist" />}
                    placeholder={intl.formatMessage({ id: 'Specialist' })}
                    name={'specialist'}
                    value={selectSpecialistName}
                    data={specialistData}
                    getValue={handleSpecialistChange}
                  />
                </Col>
              </Row>

              <Row className="mt-4 items-center">
                <div className="flex justify-center">
                  <Stack
                    direction="horizontal"
                    gap={3}
                    className="items-center"
                  >
                    <ReusableButton
                      fullWidth={false}
                      variant="outlined"
                      color="#292D32"
                      fontSize="16px"
                      fontWeight="400"
                      padding="12px 25px"
                      height="44px"
                      bgColor="transparent"
                      fontFamily="Akkurat"
                      onClick={() => {
                        setIsAssignModalActive(false);
                        setIsReAssign(false);
                      }}
                    >
                      <FormattedMessage id="Cancel" />
                    </ReusableButton>

                    <ReusableButton
                      fullWidth={false}
                      variant="contained"
                      color="#F5F5F5"
                      fontSize="16px"
                      fontWeight="400"
                      padding="12px 35px"
                      height="44px"
                      bgColor="#292D32"
                      fontFamily="Akkurat"
                      onClick={() => handleAssignSpecialist()}
                    >
                      <FormattedMessage id="Save" />
                    </ReusableButton>
                  </Stack>
                </div>
              </Row>
            </Box>
          }
        />
        {/* Edit Modal  */}
      </Col>
    </Row>
  );
};

export default AppointmentDetails;
